/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
import { withStandardComponentWrapper } from 'helpers/HOC';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import useDictionary from 'lib/hooks/useDictionary';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const RTE = (props)=>{
    const isEditing = useIsEditing();
    const { text } = props?.fields || {};
    const { RenderingIdentifier, styles } = props?.params || {};
    const { getDictionaryValue } = useDictionary();
    /*
   * RENDERING
   */ const extendedTailwindVariants = tv({
        extend: TAILWIND_VARIANTS,
        slots: {
            base: [
                styles?.trimEnd()
            ]
        }
    });
    const { base, contentContainer } = extendedTailwindVariants();
    let richTextField = text;
    if (!text || text.value === '') {
        richTextField = {
            ...text,
            value: getDictionaryValue('RTEText')
        };
    }
    const children = /*#__PURE__*/ _jsx(RichTextWrapper, {
        field: richTextField,
        ...getTestProps(`rich-text`)
    });
    return /*#__PURE__*/ _jsx("div", {
        className: base(),
        "data-component": "authorable/shared/content/rte",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        ...getTestProps(`component-rte-${props?.rendering?.uid}`),
        children: /*#__PURE__*/ _jsx("div", {
            className: contentContainer(),
            children: children
        })
    });
};
export const Default = withStandardComponentWrapper(RTE);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [],
        contentContainer: [],
        placeholder: [
            'is-empty-hint'
        ]
    }
});
